
import { Component, Prop, Vue } from "vue-property-decorator";

export default class App extends Vue {}
